import Ticker from "./components/Ticker";
import NavBar from "./components/NavBar";
import Hero from "./components/Hero";
import TopicZone from "./components/TopicZone";
import Scoops from "./components/Scoops";
import FlashFeed from "./components/FlashFeed";
import SneakPeek from "./components/SneakPeek";
import CollageZone from "./components/CollageZone";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="bg-background-50 text-foreground-950">
      <Ticker />
      <NavBar />
      <main>
        <Hero />
        <TopicZone />
        <Scoops />
        <FlashFeed />
        <SneakPeek />
        <CollageZone />
      </main>
      <Footer />
    </div>
  );
}